// extracted by mini-css-extract-plugin
module.exports = {"root":"LearnTheoryExam_root__1IHOM","subtitle":"LearnTheoryExam_subtitle__2eO_D","text":"LearnTheoryExam_text__1dOe0","links":"LearnTheoryExam_links__3BWLj"};